module.exports = __webpack_public_path__ + "static/img/present_2.8eeb626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/present_2.png
// module id = zWQd
// module chunks = 1